module.exports = __webpack_public_path__ + "img/overbooking.60ff04b8.svg";